import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { MapPin } from 'lucide-react'
import { UseFormReturn } from 'react-hook-form'

export const LocationInput = ({form,disabled}:{form:UseFormReturn<any>,disabled?:boolean}) => {
    return (
        <FormField
            control={form.control}
            name="location"
            render={() => (
                <FormItem className="space-y-2">
                    <Label htmlFor="location" className="text-base font-semibold flex items-center gap-2">
                        <MapPin className="w-5 h-5" />
                        Location
                    </Label>
                    <FormControl>
                        <Input
                            id="location"
                            placeholder="Enter location"
                            {...form.register("location")}
                            //required
                            className={`w-full transition-all duration-200 focus:ring-2 focus:ring-[#22b4b1] ${
                                form.formState.errors["employmentType"] ? "border-red-500" : "border"
                            }`}
                            disabled={disabled}
                            />
                    </FormControl>
                    {form.formState.errors["location"] && (
                        <FormMessage className="text-red-500"/>
                    )}
                </FormItem>
            )}
        />
  )
}
